import { Status } from '../../enums/status.enum';

/**
 * A container to store DTO status data
 */
export class DtoStatusContainer {
  /** A get accessor for the DTO's status text */
  public get text(): string {
    switch (this.code) {
      case Status.OK:
        return 'OK';
      case Status.Created:
        return 'Created';
      case Status.NoData:
        return 'No Data';
      case Status.NotModifed:
        return 'No Modified';
      case Status.BadRequest:
        return 'Bad Request';
      case Status.NotAuthorized:
        return 'Not Athorized';
      case Status.ImATeapot:
        // tslint:disable-next-line:quotemark
        return "I'm a Teapot";
      case Status.Error:
        return 'Error';
      default:
        return 'Unknown';
    }
  }

  /**
   * The DTO's message text
   */
  public message?: string;

  /**
   * @param code - The DTO's status code
   */
  constructor(public code: Status = Status.OK) {}

  /**
   * Determine whether the status is an error code
   */
  public isError(): boolean {
    if (
      this.code === Status.OK ||
      this.code === Status.NoData ||
      this.code === Status.Created ||
      this.code === Status.NotModifed
    ) {
      return false;
    }
    return true;
  }

  /**
   * Determine whether the status is not an error code
   */
  public isNotError(): boolean {
    if (
      this.code === Status.OK ||
      this.code === Status.NoData ||
      this.code === Status.Created ||
      this.code === Status.NotModifed
    ) {
      return true;
    }
    return false;
  }
}
